import { render, staticRenderFns } from "./ProtocolsTable.vue?vue&type=template&id=c165ab7e&scoped=true&"
import script from "./ProtocolsTable.vue?vue&type=script&lang=js&"
export * from "./ProtocolsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolsTable.vue?vue&type=style&index=0&id=c165ab7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c165ab7e",
  null
  
)

export default component.exports